import '../css/flipbook_embed_mini_page.css';
import './static/swfobject.2.1';
import 'jquery-migrate';
import $ from 'jquery';
import getParentOrigin from './flipbook_parent_origin';

window.jQuery = window.$j = window.$ = $; // Needed for flipbook scripts below
// Use require for these to ensure they load after the above line
require('./flipbook3/default');
require('./flipbook3/util');

function init({
  wMode,
  g_files_url,
  flashVars,
  bgColor,
  allowFlashPlayer,
  embedVersion,
  width,
  height,
  url,
  miniUrl,
}) {
  // Uses in a mixed content situation, letting parent know it's loaded
  if (window.postMessage) {
    window.parent.postMessage('loaded', getParentOrigin());
  }

  $(document).ready(function () {
    if (!window.swfobject) {
      return;
    }
    const flashvars = false;
    const params = {
      allowScriptAccess: 'always',
      bgColor: bgColor,
      flashvars: flashVars,
      wmode: wMode,
    };
    const attributes = { id: 'mini_flipbook' };
    const playerVersion = window.swfobject.getFlashPlayerVersion();
    const mf_flash_version = '7.0.0'; //required flash version

    if (allowFlashPlayer && playerVersion.major > 0) {
      window.swfobject.embedSWF(
        `${g_files_url}vendors/mini/mini3.swf?v=${embedVersion}>`,
        'mini_flipbook',
        `${width}`,
        `${height}`,
        mf_flash_version,
        url,
        flashvars,
        params,
        attributes,
      );
    } else {
      $('#mini_flipbook').html(`
        <div class='cover'>
          <a target='_blank' href='${miniUrl}'></a>
        </div>
        <div class='cover_link'>
          <a target='_blank' href='${miniUrl}'>Read</a>
        </div>
      `);
    }
  });
}

export { init };
